<script>
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Calculator from '@/components/demurrage/Calculator';

import { useVuelidate } from '@vuelidate/core';

export default {
    props: ['id'],

    setup: () => ({ v$: useVuelidate() }),

    components: {
        Calculator,
    },
    data() {
        return {};
    },
    validations() {
        return {};
    },
    computed: {
        constants() {
            return CommonConstants;
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
    },
    created() {
        this.$store.dispatch('security/setNavbarTitle', this.$t("DemurrageCalculator.page_title"));
    },
    mounted() {},
    methods: {},
};
</script>

<template>
    <main>
        <Calculator :id="id"/>
    </main>
</template>

<style scoped>
.align-right {
    display: flex;
    justify-content: flex-end;
}
</style>
